<template>
    <div class="nav-item avatar" v-if="isLogin">
        <a class="" @click="handleShowDropdown">
            <div class="avatar-wrap nav-avatar" :style="{'background-image': `url('${avatarUrl}')`}"></div>
            <span class="ui-icon icon-icon_down-2" v-if="!isMobile"></span>
        </a>
        <div class="nav-dropdown" :class="{show: showDropdown}">
            <i class="border-gradient ui-gradient-blue" v-if="!isMobile"></i>
            <ul>
                <li>
                    <a :href="profileUrl"
                        target="_blank"
                        @click="sendSimpleEvent('cloud-account settings')"
                    >{{ $t("dashboard.accountSettings") }}</a></li>
                <li><a :href="myPaymentUrl" target="_blank">{{ $t("dashboard.myPayments") }}</a></li>
                <li><a @click="logOut">{{ $t("login.logOut") }}</a></li>
            </ul>
        </div>
    </div>
    <div class="nav-item avatar l" v-else>
        <a
            :href="loginDashboardUrl"
            target="_blank"
        >
            <div class="avatar-wrap nav-avatar" :style="{'background-image': `url('${defaultAvatar}')`}"></div>
        </a>
    </div>
</template>

<script lang="ts">
import { getRedirectUrl } from '@/common/js/url';
import { config } from '@/config/reolink';
import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import reolinkGa from '@/common/js/gtagPageview';

export default Vue.extend({
    props: {
        isLogin: Boolean,
    },
    data() {

        return {
            showDropdown: false,
        };

    },
    computed: {
        ...mapGetters( ['avatarUrl', 'isMobile'] as const ),
        loginDashboardUrl (): string {

            return config.accountCenterLoginUrl + '?redirect=' + getRedirectUrl( '/user/dashboard/' );

        },
        profileUrl (): string {

            return config.accountCenterProfileUrl;

        },
        myPaymentUrl (): string {

            return config.myPaymentUrl;

        },
        defaultAvatar (): string {

            return config.defaultAvatar;

        },
        loginTargetUrl (): string {

            return config.accountCenterLoginUrl + '?redirect=' + getRedirectUrl( '/user/dashboard/' );

        },

        signUpTargetUrl (): string {

            return config.accountCenterSignupUrl + '?redirect=' + getRedirectUrl( '/user/dashboard/#signup' );

        },
    },
    methods: {

        logOut () {

            this._logOut();
            window.location.href = config.accountCenterLogoutUrl + '?redirect=' + getRedirectUrl( '/' );

        },
        logIn () {

            window.location.href = this.loginTargetUrl;

        },

        signUp () {

            window.location.href = this.signUpTargetUrl;

        },

        ...mapMutations({

            _logOut: 'LOGOUT',

        }),
        handleShowDropdown () {

            if ( !this.isMobile ) {

                return;

            }

            this.showDropdown = !this.showDropdown;

        },
        sendSimpleEvent( type ) {

            reolinkGa.sendSimpleEvent( type );

        }
    }
});
</script>

<style lang="less" scoped>
.nav-item .nav-dropdown{
    display: none;
    background-color: #fff;
    -o-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    -ms-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    z-index: 99;
    opacity: 1;
    position: absolute;
    left: 50%;
    top: 83px;
    transform: translateX(-55%);
    .mobile({
        left: auto;
        right: 20px;
        top: 61px;
        transform: none;
        border-radius: @border-radius-level-small;
        padding: 10px 16px;
        background-color: @bg_02;
    })
}

.dashboard .nav-dropdown{
    margin-left: -.45rem;
}

#header .nav-dropdown li{
    position: relative;
    white-space: nowrap;
    &:not(:last-child) a{
        .mobile({
            border-bottom: 1px solid #f1f1f1;
            padding-bottom: 8px;
        });
    }
    &:not(:first-child) a{
        .mobile({
            padding-top: 8px;
        });
    }
}
#header .nav-dropdown li a{
    padding: 0 .2rem;
    color: #555;
    font-size: .16rem;
    font-weight: 500;
    text-decoration: none;
    display: block;
    text-align: center;
    line-height: .6rem;
    border-bottom: 0;
    margin: 0;
    .mobile({
        display: flex;
        justify-content: center;
        font-size: 14px;
        line-height: 21px;
    })
}
#header .nav-dropdown li a:hover{
    background-color: #f7f8f9;
    color: @theme;
}

#header .pc-body .nav-item:hover .nav-dropdown{
    display: block;
}

#header .nav-item .nav-dropdown.lang-nav-dropdown {
    transform: ~'translateX(calc(-60% + 2px))';
    li{
        line-height: .4rem;
        a{
            line-height: .4rem;
        }
    }

}

#header .pc-body .avatar .ui-icon{
    top: -.15rem;
    color: #333;
}

.avatar .nav-avatar{
    height: .38rem;
    width: 0.38rem;
    border-radius: 50%;
    margin-top: .23rem;
    border: 1px solid #f1f1f1;
    display: inline-block;
    .mobile({
        width: 28px;
        height: 28px;
        margin-top: 0;
    })
}

#header .pc-body .avatar a{
    display: block;
}

#header .avatar>a {
    height: 0.88rem;
    color: #333;
    font-size: .16rem;
    .mobile({
        display: flex;
        height: auto;
    });

    &:hover {
        color: @theme;
    }
}

.nav-item{
    display: flex;
    gap:4px;
    align-items: center;
}

.ui-icon{
    font-size: 16px;
    margin-left: 4px;
    position: relative;
    top: -.02rem;
}

.show{
    display: block !important;
}

.nav-dropdown::before{
    .mobile({
        content: '';
        position: absolute;
        top: -8px; /* 箭头高度 */
        right: 7px; /* 水平位置 */
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 8px solid @bg_02;
    });
}
</style>
